import { render, staticRenderFns } from "./MordaLentaWin.vue?vue&type=template&id=55f4744e"
import script from "./MordaLentaWin.vue?vue&type=script&lang=js"
export * from "./MordaLentaWin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports